/**
* JavaScript Graphical User Interface
* Defining GUI.Forms.Validation namespace
*
* @author Eugene Lyulka
* @version 2.0
* @namespace GUI.Forms
*/
GUI.Forms.Validation = {};
